<script>
  import { router } from '@inertiajs/svelte'

  let { notice = '', alert = '', email_hint = '' } = $props();

  let email = $state('');
  let password = $state('');
  let errors = $state({});

  $effect(() => {
    if (email_hint) {
      email = email_hint;
    }
  });

  function submit(event) {
    event.preventDefault();
    router.post('/sign_in', {
      email,
      password,
    });
  }

  function signInWithOmniAuth() {
    // Direct link to Google OAuth - OmniAuth is configured to allow GET requests
    window.location.href = '/auth/google';
  }
</script>

<div class="login-container">
  {#if notice}
    <div class="notice-message">{notice}</div>
  {/if}

  {#if alert}
    <div class="alert-message">{alert}</div>
  {/if}

  <h1>Sign in</h1>

  <form onsubmit={submit}>
    <div class="form-group">
      <label for="email" class="form-label">Email</label>
      <!-- svelte-ignore a11y_autofocus -->
      <input
        id="email"
        type="email"
        bind:value={email}
        required
        autofocus
        autocomplete="email"
        class="form-input"
      />
    </div>

    <div class="form-group">
      <label for="password" class="form-label">Password</label>
      <input
        id="password"
        type="password"
        bind:value={password}
        required
        autocomplete="current-password"
        class="form-input"
      />
    </div>

    <div class="form-actions">
      <button type="submit" class="signin-button">Sign in</button>
    </div>
  </form>

  <div class="additional-options">
    <button onclick={signInWithOmniAuth} class="oauth-button">Sign in with Google</button>
  </div>

  <div class="help-links">
    <a href="/sign_up">Sign up</a> |
    <a href="/identity/password_reset/new">Forgot your password?</a>
  </div>
</div>

<style>
  .login-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  .notice-message {
    background-color: #ecfdf5;
    border: 1px solid #10b981;
    color: #047857;
    border-radius: 0.375rem;
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .alert-message {
    background-color: #fee2e2;
    border: 1px solid #ef4444;
    color: #b91c1c;
    border-radius: 0.375rem;
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .form-group {
    margin-bottom: 1.25rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.375rem;
  }
  
  .form-input {
    width: 100%;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1rem;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .signin-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .signin-button:hover {
    background-color: #065f46;
  }
  
  .additional-options {
    margin-top: 1.5rem;
  }
  
  .oauth-button {
    background-color: #ffffff;
    color: #757575;
    border: 1px solid #dadce0;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  }
  
  .oauth-button:hover {
    background-color: #f8f9fa;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12);
  }
  
  .oauth-button:before {
    content: "";
    display: inline-block;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' width='24px' height='24px'%3E%3Cpath fill='%23FFC107' d='M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z'/%3E%3Cpath fill='%23FF3D00' d='M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z'/%3E%3Cpath fill='%234CAF50' d='M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z'/%3E%3Cpath fill='%231976D2' d='M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z'/%3E%3C/svg%3E");
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  
  .help-links {
    margin-top: 1.5rem;
    text-align: center;
    font-size: 0.875rem;
  }
  
  .help-links a {
    color: #047857;
    text-decoration: none;
  }
  
  .help-links a:hover {
    text-decoration: underline;
  }
</style>
